var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carregando"},[_c('i',{staticClass:"fa fa-refresh fa-spin"}),_vm._v(" "+_vm._s(_vm._traducao('global', 'carregando'))+"...")])}
var staticRenderFns = []

export { render, staticRenderFns }